//文字コードはutf-8
// アンカー

export function loadmore() {
$(function() {

  const $items = $('.jsLoadItem');
  const $btn = $('.jsLoadBtn');

  // Hide initially
  $items.hide();

  const $container = $(window);
  const initialOffset = $container.scrollTop();

  $btn.on('click', function() {
    const isOpen = $btn.hasClass('is-act');

    if (isOpen) {
      $items.fadeOut(300);
      $btn.removeClass('is-act');
      $btn.text('注意事項をもっと見る');

      $container.stop(true).animate({ scrollTop: initialOffset }, 300, 'swing');

    } else {
      $items.fadeIn(300);
      $btn.addClass('is-act');
      $btn.text('閉じる');
    }
  });

});





}